<style lang="scss" scoped>
.slide-15 {
  background-image: url(../../../assets/module3/slide15/background-01.jpg);
  background-position: center;
  background-size: cover;
  background-color: #fff;
  padding-top: 60px;
  height: calc(100%);
  padding-left: 0;
  padding-top: 0;

  .timmy {
    margin-left: -150px;
  }

  h1,
  h2 {
    display: flex;
    flex-direction: column;
  }

  h1 {
    color: #09509c;
    font-size: 100px;
    transform: rotate(-3deg);
    margin-bottom: 43px;
    span {
      &:nth-of-type(2) {
        transform: translateX(225px);
      }
    }
  }

  h2 {
    transform: rotate(-5deg);
    text-align: center;
    width: 658px;
    margin-right: 0;
    margin-top: 70px;
    margin-left: auto;
    span {
      color: #c89208;
      font-size: 64px;
    }
  }

  .heading1 {
    color: #c5d43b;
    font-size: 60px;
  }
  .heading2 {
    color: #3b7fc2;
    font-size: 120px;
  }
  .heading3 {
    color: #c5d43b;
    font-size: 60px;
    margin-left: 250px;
    transform: rotate(-5deg);
    transform-origin: 10% 0;
  }
  .heading4 {
    color: #c5d43b;
    font-size: 60px;
    margin-left: 300px;
    transform: rotate(-5deg);
    transform-origin: 10% 0;
  }

  .images {
    position: absolute;
    top: 0;
    left: 0;
  }
  .content {
    position: absolute;
    top: 0;
    left: 0;
    padding: 130px 125px;
  }

  .copy1,
  .copy2,
  .copy3,
  .heading5 {
    width: 655px;
    margin: 0 0 30px 577px;
  }

  .heading5 {
    color: #edad0a;
    font-size: 40px;
  }
  video {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 100%;
    z-index: 10;
    box-shadow: 0px 0px 0px 100vw rgba(0, 0, 0, 0.9);
  }

  .high-five {
    transform: scale(1);
    position: absolute;
    right: 190px;
    top: 50px;
    width: 200px;
    cursor: pointer;
    z-index: 10;
  }
}
</style>

<template>
  <div class="slide-15">
    <transition name="fadeLeft" appear>
      <img
        class="delay-1 chars"
        v-show="slideIndex == 14"
        src="@/assets/module3/slide15/armando-01.png"
      />
    </transition>
    <transition name="fadeRight" appear>
      <img
        class="delay-5 images"
        v-show="slideIndex == 14"
        src="@/assets/module3/slide15/images-01.png"
      />
    </transition>

    <div class="content">
      <transition name="fadeLeft" appear>
        <div v-show="slideIndex == 14">
          <h1 v-html="$t('module3.slide15.heading1')"></h1>
        </div>
      </transition>

      <transition name="fadeRight" appear>
        <div class="delay-3" v-show="slideIndex == 14">
          <p class="copy1">{{ $t("module3.slide15.copy1") }}</p>
        </div>
      </transition>

      <transition name="fadeRight" appear>
        <div class="delay-4" v-show="slideIndex == 14">
          <p class="copy2">{{ $t("module3.slide15.copy2") }}</p>
        </div>
      </transition>
      <transition name="fadeUp" appear>
        <div class="delay-4" v-show="slideIndex == 14">
          <h2
            v-show="slideIndex == 14"
            v-html="$t('module3.slide15.heading2')"
          ></h2>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
